<template>
  <div class="outer-wrapper">
    <div class="editor-wrapper" v-show="!sampleShow">
      <div class="title-wrapper">
        <span>待接收样品</span>
      </div>
      <van-search
  v-model="taskNo"
  placeholder="请输入任务单号"
  input-align="center"
  @search="onSearch"
/>
      <van-list
        v-model="sampleTable.loading"
        :finished="sampleTable.finished"
        finished-text="没有更多了"
        :error.sync="sampleTable.error"
        error-text="请求失败，点击重新加载"
        @load="onLoad"
      >
        <van-cell
          v-for="item in sampleTable.tivdata"
          :key="item.project_display_no+'verify'"
          :title="item.sample_name+'('+sampleDisplayNoAbbr(item.sample_display_no)+')'"
          @click="chooseSample(item)"
          is-link
        >
          <span class="cell-item">{{item.create_time.split(" ")[0]}}</span>
          <span class="cell-item">{{item.sample_stat}}</span>
        </van-cell>
      </van-list>
    </div>
    <div class="report-wrapper" v-show="sampleShow">
      <van-nav-bar
        :title="'样品签收('+sampleDisplayNoAbbr(currentSample.sample_display_no)+')'"
        left-text="返回"
        left-arrow
        @click-left="onClickBack"
        fixed
      ></van-nav-bar>
      <van-cell title="样品名称" :value="currentSample.sample_name" />
      <van-cell title="型号" :value="currentSample.sample_model?currentSample.sample_model:'无'" />
      <van-panel title="其他属性：" desc status>
        <div class="d-wrapper">
          <p>{{currentSample.other_property?currentSample.other_property:'无'}}</p>
        </div>
      </van-panel>
      <van-panel title="上传样品图片：" desc status>
        <div class="d-wrapper">
          <van-uploader
            :after-read="handleAfterRead"
            :before-delete="handleBeforeDelete"
            deletable
            v-model="imgList"
            capture="camera"
          />
        </div>
      </van-panel>
      <van-panel title="选择签收状态：" desc status>
        <div class="d-wrapper">
          <van-radio-group v-model="currentSample.sample_stat">
            <van-radio
              :name="ele"
              class="radio-item"
              v-for="ele in statList"
              :key="ele+'stat'"
            >{{ele}}</van-radio>
          </van-radio-group>
        </div>
      </van-panel>
      <div class="button-wrapper">
        <van-button color="#ee0a24" class="submit" @click="checkSubmit" :disabled="!submitAbled">提交</van-button>
        <van-button
          color="#ee0a24"
          class="submit"
          plain
          style="margin-left:1rem;"
          @click="onClickBack"
        >取消</van-button>
      </div>
    </div>
  </div>
</template>
<script>
let userToken = localStorage.getItem("current_user_token");
let authData = JSON.parse(localStorage.getItem("authData"));
import { textTrans } from "@/mixins/TextTrans.js";

function sampleTableFac() {
  return {
    loading: false,
    finished: false,
    error: false,
    Tpage: {
      currentPage: 1,
      currentSize: 20
    },
    no_data_text: "",
    totalItems: 0,
    tivdata: [
      /*{
            sample_name: NaN,
            project_display_no:NaN,
            sample_amount: NaN,
            sample_model:"",
            other_property:"",
            company_name:"",
            customer_account:"",
            customer_name:"",
            create_time:"",
            sample_stat:"",
            receive_time:""
          }*/
    ]
  };
}

export default {
  name: "sampleManage",
  components: {},
  mixins: [textTrans],
  data() {
    return {
      sampleTable: sampleTableFac(),
      sampleShow: false,
      currentSample: {
        sample_display_no:''
      },
      currentSampleCompare: {},
      imgList: [],
      imgDeleted: [],
      taskNo:'',
      selected_list: [
        {
          category_t: "样品状态",
          value: "部分签收",
          text: "部分签收",
          key_name: "stat"
        },
        {
          category_t: "样品状态",
          value: "待收取",
          text: "待收取",
          key_name: "stat"
        }
      ],
      statList: ["全部签收", "部分签收", "待收取"],
      imgAlter: false
    };
  },
  watch: {},
  computed: {
    submitAbled: function() {
      if (
        this.imgList.findIndex(val => val.obj !== undefined) !== -1 ||
        this.currentSample.sample_stat !==
          this.currentSampleCompare.sample_stat ||
        this.imgDeleted.length > 0 ||
        this.imgAlter
      ) {
        return true;
      } else {
        return false;
      }
    }
  },
  created() {},
  methods: {
    onSearch(){
      this.sampleTable.tivdata = [];
      this.sampleTable.Tpage.currentPage = 1;
      this.sampleTable.Tpage.currentSize = 20;
      this.sampleTable.finished = false;
      this.onLoad();
    },
    onLoad() {
      this.sampleTable.loading = true;
      this.$axios
        .post(this.$url + "/ask_list_data", {
          page: this.sampleTable.Tpage,
          userToken: userToken,
          ask_data: "sampleManageList",
          selected_list: this.selected_list,
          keyword: '',
          taskNo:this.taskNo
        })
        .then(response => {
          for (let ele of response.data.res_record) {
            this.sampleTable.tivdata.push(ele);
          }
          if (
            response.data.res_record.length < this.sampleTable.Tpage.currentSize
          ) {
            this.sampleTable.finished = true;
          }
          this.sampleTable.loading = false;
          this.sampleTable.Tpage.currentPage++;
        });
    },
    chooseSample(val) {
      this.currentSample = val;
      this.currentSampleCompare = JSON.parse(JSON.stringify(val));
      let tmp = JSON.parse(val.sample_img);
      this.imgList = [];
      if (tmp) {
        for (let i of tmp.urlList) {
          this.imgList.push({ url: this.$fileUrlFac(i, authData.sfileRight) });
        }
      }
      this.sampleShow = true;
    },
    onClickBack() {
      this.sampleShow = false;
      this.currentSample = {
        sample_display_no:''
      };
      this.currentSampleCompare = {};
      this.imgList = [];
    },
    checkSubmit() {
      if (this.submitAbled) {
        let form = new FormData();
        form.append("userToken", userToken);
        form.append("sid", this.currentSample.sample_id);
        form.append("stat", this.currentSample.sample_stat);
        form.append("imgDeleted", JSON.stringify(this.imgDeleted));
        for (let img of this.imgList) {
          if (img.obj !== undefined) {
            form.append("sampleImg", img.obj);
          }
        }
        let config = {
          headers: { "Content-Type": "multipart/form-data" }
        };
        this.$axios
          .post(this.$url + "/update_sample", form, config)
          .then(response => {
            if (response.data.stat === "ok") {
              if (this.currentSample.sample_stat === "全部签收") {
                this.$toast.success("样品签收成功！");
              } else {
                this.$toast.success("样品信息更新成功！");
              }
              this.onClickBack();
              this.sampleTable = sampleTableFac();
              this.onLoad();
            } else {
              this.$toast.fail(response.data.error_info);
            }
          })
          .catch(error => {
            this.$toast.fail(error + "网络连接失败！");
          });
      }
    },
    handleAfterRead(img, detail) {
      if (img.file.size < 1024 * 200) {
        this.imgList[detail.index].obj = img.file;
      } else {
        let vm = this;
        var reader = new FileReader();
        reader.readAsDataURL(img.file);
        reader.onload = function(e) {
          let img = new Image();
          img.src = e.target.result;
          img.onload = function() {
            let width = 800, //图像大小
              quality = 0.7, //图像质量
              canvas = document.createElement("canvas"),
              drawer = canvas.getContext("2d");
            canvas.width = width;
            canvas.height = width * (img.height / img.width);
            drawer.drawImage(img, 0, 0, canvas.width, canvas.height);
            vm.imgList[detail.index].url = canvas.toDataURL(
              "image/jpeg",
              quality
            );
            vm.imgList[detail.index].obj = vm.convertBase64UrlToFile(
              vm.imgList[detail.index].url,
              "img" + detail.index + ".jpeg"
            );
            this.imgAlter = true;
          };
        };
      }
    },
    handleBeforeDelete(img) {
      if (img.url !== undefined) {
        this.imgDeleted.push(img.url);
      } else {
        if (this.imgList.findIndex(val => val.obj !== undefined) === -1) {
          this.imgAlter = false;
        }
      }
      return true;
    },
    convertBase64UrlToFile(urlData, filename) {
      let arr = urlData.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    }
  }
};
</script>
<style scoped>
.inner-wrapper {
  width: 100%;
  background: #f7f7f7;
  min-height: 20rem;
}

.title-wrapper {
  text-align: center;
  font-size: 0.8rem;
  color: #999;
  padding: 1rem;
  background: #fff;
  border-bottom: 1px solid #f6f6f6;
}

.editor-wrapper {
  width: 100%;
}
.cell-item {
  margin-left: 0.6rem;
}

.op {
  outline: none;
  border: 1px solid #eee;
  color: #fff;
  background: rgb(11, 155, 18);
  font-weight: 400;
  height: 1rem;
  position: relative;
  top: 0.05rem;
  padding: 0.15rem 0.5rem;
  border-radius: 0.2rem;
}
.deny {
  background: rgb(228, 46, 14);
  margin-left: 0.5rem;
}

.text-wrapper {
  padding: 0.1rem 0.5rem;
}
.text-wrapper-con {
  padding: 1rem 0 1rem 2rem;
}

.textarea {
  width: 100%;
  height: 7rem;
}
.bold-text {
  font-weight: 600;
  color: #666;
}
.d-wrapper {
  padding: 0.5rem 1rem;
  text-align: center;
  font-size: 0.6rem;
}
.button-wrapper {
  padding: 2rem;
  text-align: center;
}
.radio-item {
  margin-top: 1rem;
  margin-left: 30%;
}
</style>